import { useState } from 'react';

import { ArrowLeftIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import Button from '@/components/ui/button';
import { InputWithLabel } from '@/components/ui/input';
import { ResetLink } from '@/services/auth';
import { useTrackPageView } from '@/services/track';

const ForgotPassword = () => {
  useTrackPageView();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    ResetLink({ email })
      .then(() => setEmailSent(true))
      .catch(() => setEmailSent(true));
  };

  return (
    <>
      <div className="absolute left-4 top-4 flex items-center gap-2 text-secondary">
        <Button
          variant="icon"
          className="h-16 hover:text-white"
          onClick={() => navigate(-1)}
        >
          <ArrowLeftIcon />
        </Button>
        <span>Back</span>
      </div>

      {emailSent ? (
        <div className="mx-auto flex max-w-[400px] flex-col items-center gap-8">
          <svg
            width="112"
            height="112"
            viewBox="0 0 112 112"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M47.2952 66.2184L35.8702 55.214L32.0619 58.8822L47.2952 73.5547L79.9381 42.1136L76.1298 38.4454L47.2952 66.2184Z"
              fill="#00FF85"
            />
            <rect
              x="1"
              y="1"
              width="110"
              height="110"
              rx="55"
              stroke="#00FF85"
              strokeWidth="2"
            />
          </svg>
          <h1 className="text-center text-[48px]">Check your email</h1>
          <p className="text-center text-[16px]">
            If you registered before with the email address <b>{email}</b> you
            will receive instructions to create new password
          </p>
          <Button variant="link" onClick={() => setEmailSent(null)}>
            Change email
          </Button>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <h1 className="text-center text-[48px]">Forgot password?</h1>

          <div className="mx-auto mt-20 flex max-w-[400px] flex-col items-center gap-8">
            <p>
              Enter the email you used to login, so we can send you a link to
              create a new password
            </p>

            <InputWithLabel
              label="Email"
              name="email"
              type="email"
              placeholder="Enter your email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <Button variant="primary" type="submit">
              send link to reset
            </Button>
          </div>
        </form>
      )}
    </>
  );
};

export default ForgotPassword;
